import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router'

class MenuItem extends Component {
  constructor() {
    super()
    this.state = { active: false }
    this.toggleActive = this.toggleActive.bind(this)
  }

  static propTypes = {
    translate: PropTypes.func.isRequired,
    menu: PropTypes.object.isRequired,
  }

  toggleActive() {
    if (this.state.active) {
      this.setState({ active: false })
    } else {
      this.setState({ active: true })
    }
  }

  renderLink(menu) {
    const { translate } = this.props

    const activeClass = classNames('navigation-menu-item', {
      active: this.state.active,
    })

    return (
      <Link to={`/${menu.dsView}`}>
        <li className={activeClass} onClick={this.toggleActive}>
          <span className='navigation-name'>
            <i className={`glyph ${menu.nmImage}`} />
            {translate(menu.dsChaveMenu)}
          </span>
        </li>
      </Link>
    )
  }

  renderItem(menu) {
    const { translate } = this.props

    const activeClass = classNames('navigation-menu-item', {
      active: this.state.active,
    })

    return (
      <li className={activeClass} onClick={this.toggleActive}>
        <span className='navigation-name'>
          <i className={`glyph ${menu.nmImage}`} />
          {translate(menu.dsChaveMenu)}
        </span>
      </li>
    )
  }

  render() {
    const { menu } = this.props

    return menu.dsView ? this.renderLink(menu) : this.renderItem(menu)
  }
}

export default MenuItem
